var _path, _path2, _g, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 242,
    viewBox: "0 0 296 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18400_83000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.139 39.2779C135.616 27.1646 95.0476 -11.4798 55.2847 3.94341C15.5217 19.3667 5.41705 47.3885 1.29049 93.3717C-2.83606 139.355 42.8254 200.055 66.6868 209.179C125.787 231.78 138.746 257.957 172.057 227.576C209.526 193.403 201.394 188.636 232.431 158.155C252.316 138.626 292.305 128.498 293.172 105.819C294.039 83.1402 299.227 37.525 263.981 21.2973C228.734 5.06955 213.682 57.1629 167.139 39.2779Z",
    fill: "#00C6C6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18400_83000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 294,
    height: 242
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.072 39.3369C136.543 27.2934 96.0122 -11.2336 56.1802 4.24099C16.3481 19.7156 6.17781 47.7216 1.95553 93.6569C-2.26676 139.592 43.3176 200.139 67.1838 209.211C126.296 231.681 139.215 257.804 172.619 227.401C210.192 193.203 202.062 188.456 233.189 157.957C253.133 138.416 293.181 128.231 294.094 105.577C295.007 82.924 300.291 37.3543 265.043 21.2078C229.795 5.06137 214.624 57.1188 168.072 39.3369Z",
    fill: "#00C6C6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18400_83000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.9 177.664C163.862 203.112 181.565 243.004 147.487 245.012C110.053 247.219 60.0857 261.426 38.2257 230.625C14.2947 196.906 60.8451 152.818 53.4492 112.513C47.6124 80.7055 -0.570993 64.3117 1.82356 32.2516C4.18799 0.594563 33.4411 -28.4617 64.5077 -35.5476C94.8644 -42.4715 120.93 -13.108 150.273 -1.60776C167.404 5.10646 238.95 6.06658 256.114 12.6934C269.293 9.26602 278.989 -30.4094 300.462 37.1487C312.828 61.4125 259.169 95.9862 253.779 122.271C247.145 154.627 207.439 152.791 185.9 177.664Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4845 217.166C103.455 181.45 135.399 201.923 155.883 167.454C181.489 124.367 139.9 95.9958 174.595 80.6917C209.289 65.3875 259.888 55.1018 261.227 39.0354C262.298 26.1823 251.492 17.8696 251.465 16.2657",
    stroke: "#5B686D",
    strokeWidth: 3,
    strokeDasharray: "16 12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3096 1.55485C82.9875 23.6695 87.3344 71.3006 59.2985 84.9077C24.2537 101.916 16.8684 68.4424 11.5137 71.0803C7.22992 73.1906 4.25559 80.671 3.3039 84.1474",
    stroke: "#5B686D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "15 12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 76,
    width: 136,
    height: 33,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85,
    width: 60,
    height: 5,
    rx: 1,
    fill: "#807376"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 94,
    width: 90,
    height: 6,
    rx: 1,
    fill: "#1E273B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 87,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#1CA6AF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 121,
    width: 136,
    height: 33,
    rx: 6,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 130,
    width: 60,
    height: 5,
    rx: 1,
    fill: "#807376"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 139,
    width: 90,
    height: 6,
    rx: 1,
    fill: "#1E273B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 132,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#1CA6AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.739 33C158.739 31.4087 158.107 29.8826 156.982 28.7574C155.856 27.6321 154.33 27 152.739 27C151.148 27 149.622 27.6321 148.496 28.7574C147.371 29.8826 146.739 31.4087 146.739 33C146.739 36.0902 145.96 38.206 145.089 39.6054C144.354 40.7859 143.987 41.3761 144 41.5408C144.015 41.7231 144.054 41.7926 144.201 41.9016C144.333 42 144.932 42 146.128 42H159.35C160.546 42 161.145 42 161.277 41.9016C161.424 41.7926 161.463 41.7231 161.478 41.5408C161.491 41.3761 161.124 40.7859 160.389 39.6054C159.519 38.206 158.739 36.0902 158.739 33Z",
    fill: "#FC7292"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.093 46C150.798 46.6224 151.725 47 152.739 47C153.753 47 154.68 46.6224 155.385 46M158.739 33C158.739 31.4087 158.107 29.8826 156.982 28.7574C155.856 27.6321 154.33 27 152.739 27C151.148 27 149.622 27.6321 148.496 28.7574C147.371 29.8826 146.739 31.4087 146.739 33C146.739 36.0902 145.96 38.206 145.089 39.6054C144.354 40.7859 143.987 41.3761 144 41.5408C144.015 41.7231 144.054 41.7926 144.201 41.9016C144.333 42 144.932 42 146.128 42H159.35C160.546 42 161.145 42 161.277 41.9016C161.424 41.7926 161.463 41.7231 161.478 41.5408C161.491 41.3761 161.124 40.7859 160.389 39.6054C159.519 38.206 158.739 36.0902 158.739 33Z",
    stroke: "#FC7292",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18400_83000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 242,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotifications);
export default __webpack_public_path__ + "static/media/empty-notifications.132d4bf200ba895bd52d0fbaab4d92eb.svg";
export { ForwardRef as ReactComponent };